import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <p className="text-6xl font-bold text-muted-foreground">404</p>
      <p className="text-muted-foreground">Página não encontrada.</p>
      <Button asChild>
        <Link to="/dashboard">Voltar ao painel</Link>
      </Button>
    </div>
  );
}
